<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="fnSimpleAnnulation.infosAnnulation"
	[label]="step4.infosAnnulation" [type]="'text'" [rule]="'minSize_0|maxSize_4000|required'" [name]="getUid() + '_SepAtt_infosAnnulation'">
</app-form-input>
